import React from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { HeroSection } from "@/components/HeroSection";
import { ProcessSection } from "@/components/ProcessSection";
import { ValueProposition } from "@/components/ValueProposition";
import { WhyChoose } from "@/components/WhyChoose";
import { ServicesSection } from "@/components/ServicesSection";
import { TrustedByPlanners } from "@/components/TrustedByPlanners";
import { TestimonialsSection } from "@/components/TestimonialsSection";
import { AboutSection } from "@/components/AboutSection";
import { MeetDaren } from "@/components/MeetDaren";
import { CTASection } from "@/components/CTASection";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";

function App() {
  return (
    <div className="App font-body">
      <Toaster position="top-right" richColors />
      <Header />
      <main>
        <HeroSection />
        <ProcessSection />
        <ValueProposition />
        <WhyChoose />
        <ServicesSection />
        <TrustedByPlanners />
        <TestimonialsSection />
        <AboutSection />
        <MeetDaren />
        <CTASection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
